import moment from "moment";
import { LoadState } from "../../constants/enums";
import {
  IMaterialRequest,
  IMaterialRequestProductDetail,
  IMaterialRequestState,
} from "./MaterialRequest.types";

export const defaultMaterialRequestProductDetail: IMaterialRequestProductDetail =
  {
    product_uuid: "",
    product_name: "",
    product_unit: "",
    product_description: "",
    product_quantity: 0,
    allocated_quantity: 0,
    total_allocated_quantity: 0,
    pr_quantity: 0,
    product_price: "",
    required_by_date: "",
    remark: "",
    total: "",
  };

export const defaultMaterialRequest: IMaterialRequest = {
  material_request_uuid: null,
  material_request_date: "",
  project_uuid: null,
  project_name: null,
  product_details: [defaultMaterialRequestProductDetail],
  billing_company_uuid: null,
  billing_company_name: null,
  billing_company_branch_uuid: null,
  billing_company_branch_name: null,
  attachments: [],
  total_amount: "",
  status: "DRAFT",
};

export const defaultMaterialRequestState: IMaterialRequestState = {
  material_request_list: {
    data: [],
    totalRecords: 0,
    loading: LoadState.NotLoaded,
  },
  single_material_request: {
    data: defaultMaterialRequest,
    loading: LoadState.NotLoaded,
    error: null,
  },
};
